import { forwardRef, useEffect, useState } from "react";
import { AnimatedBlock, Quote, FloatingContentSection, VideoWrapper } from "../../styles/blocks";
import { H1, H2 } from "../../styles/type/headings";
import { AssistiveText } from "../../styles/type/typography";
import useIsInViewport from "use-is-in-viewport";
import Row from "../../styles/layout/row";
import Col from "../../styles/layout/col";
import { ClearContain, ContentContain, StandardContain } from "../../styles/layout/contain";
import { BulletList, FeatureList } from "../../styles/content";
import { ButtonList } from "../../styles/type/buttons";
import RegisterInterest from "../registerInterest";
import { VideoPlayer } from "./video";

const About1 = () => {
	const [isInViewport, targetRef] = useIsInViewport({
		threshold: 25,
	});
	const [animate, setAnimate] = useState(false);

	useEffect(() => {
		if (!animate) setAnimate(isInViewport);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isInViewport]);

	return (
		<AnimatedBlock ref={targetRef} animate={animate} fillSpace>
			<H1 small>Hello edun.</H1>
			<H1>The professional network in education.</H1>
			<AssistiveText pushTop>Say hello to edun, the all-in-one educational CRM. Complete with booking systems, timesheet management and e-onboarding.</AssistiveText>
			<RegisterInterest />
		</AnimatedBlock>
	);
};

const PromoVideo = () => {
	const [isInViewport, targetRef] = useIsInViewport({
		threshold: 25,
	});
	const [animate, setAnimate] = useState(false);

	useEffect(() => {
		if (!animate) setAnimate(isInViewport);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isInViewport]);

	return (
		<AnimatedBlock ref={targetRef} animate={animate} fillSpace>
			<VideoPlayer />
		</AnimatedBlock>
	);
};

const About2 = () => {
	const [isInViewport, targetRef] = useIsInViewport({
		threshold: 25,
	});
	const [animate, setAnimate] = useState(false);

	useEffect(() => {
		if (!animate) setAnimate(isInViewport);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isInViewport]);

	return (
		<AnimatedBlock ref={targetRef} animate={animate} fillSpace>
			<H1>So, what is Edun?</H1>
			<AssistiveText pushTop>Edun is the new, professional network in education. An all in one CRM system designed by education recruiters FOR education recruiters!</AssistiveText>
			<AssistiveText>
				Created to save you time on admin processes , whilst maintaining visibility of core business metrics and offering a completely cloud based, secure, cutting edge platform for
				independent agencies to thrive.
			</AssistiveText>
		</AnimatedBlock>
	);
};

const About2Image = () => {
	const [isInViewport, targetRef] = useIsInViewport({
		threshold: 25,
	});
	const [animate, setAnimate] = useState(false);

	useEffect(() => {
		if (!animate) setAnimate(isInViewport);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isInViewport]);

	return (
		<AnimatedBlock ref={targetRef} animate={animate} fillSpace>
			<img src="/static/images/about-2-what.png" alt="What is edun image" />
		</AnimatedBlock>
	);
};

const About3 = () => {
	const [isInViewport, targetRef] = useIsInViewport({
		threshold: 25,
	});
	const [animate, setAnimate] = useState(false);

	useEffect(() => {
		if (!animate) setAnimate(isInViewport);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isInViewport]);

	return (
		<AnimatedBlock ref={targetRef} animate={animate} fillSpace>
			<H1>Why should you move to Edun?</H1>
			<AssistiveText pushTop>
				Edun was born out of endlessly searching the market looking for a system that suited the unique needs of the education sector; one trial at a time and one subscription at a time we
				realised… it didn&apos;t exist, until now!
			</AssistiveText>
		</AnimatedBlock>
	);
};

const About3Image = () => {
	const [isInViewport, targetRef] = useIsInViewport({
		threshold: 25,
	});
	const [animate, setAnimate] = useState(false);

	useEffect(() => {
		if (!animate) setAnimate(isInViewport);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isInViewport]);

	return (
		<AnimatedBlock ref={targetRef} animate={animate} fillSpace>
			<img src="/static/images/about-3-why.png" alt="Why choose edun image" />
		</AnimatedBlock>
	);
};

const EdunQuote = () => {
	const [isInViewport, targetRef] = useIsInViewport({
		threshold: 25,
	});
	const [animate, setAnimate] = useState(false);

	useEffect(() => {
		if (!animate) setAnimate(isInViewport);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isInViewport]);

	return (
		<AnimatedBlock ref={targetRef} animate={animate} fillSpace>
			<Quote>
				<figure>
					<blockquote>
						<p>
							Edun was developed due to the need for a system that allowed my education recruitment business to function as efficiently as possible. Removing tiresome admin processes
							allowed our teams to focus on what matters most - building relationships and generating business leads. Edun is a slick , smooth and easy to use all in one package that
							really has revolutionised our productivity and workflow
						</p>
						<figcaption>
							Douglas Scott<cite>Founder, Edun</cite>
						</figcaption>
					</blockquote>
				</figure>
			</Quote>
			<Quote>
				<figure>
					<blockquote>
						<p>
							<span style={{ display: "block" }}>&#11088;&#11088;&#11088;&#11088;&#11088;</span>
							5* Great system for us. Very easy to use and the team are always there if we need any support
						</p>
						<figcaption>
							Kiera<cite>Edun Customer</cite>
						</figcaption>
					</blockquote>
				</figure>
			</Quote>
			<Quote>
				<figure>
					<blockquote>
						<p>
							<span style={{ display: "block" }}>&#11088;&#11088;&#11088;&#11088;&#11088;</span>
							5* Edun is an excellent CRM facility specifically aimed at Education recruiters. I have used many CRMS over the years and nothing compares. Edun really is easy to follow
							for compliance, database, sending out application forms, references and many more aspects. It really is a straight forward facility. The staff are also always on hand, with
							excellent customer service. I highly recommend Edun
						</p>

						<figcaption>
							Cassie<cite>Edun Customer</cite>
						</figcaption>
					</blockquote>
				</figure>
			</Quote>
			<Quote>
				<figure>
					<blockquote>
						<p>
							I’ve been in the sector almost 15 years as a Compliance Manager and I can honestly say Edun is the best product on the market. Also, the service of their team to help with
							changes etc is second to none
						</p>

						<figcaption>
							Michael<cite>Edun Customer</cite>
						</figcaption>
					</blockquote>
				</figure>
			</Quote>
			<Quote>
				<figure>
					<blockquote>
						<p>
							If you are in education recruitment, give this a demo. Its a fantastic system and I’ve used quite a few over the years. There are some great CRMs out there, but this is by
							far the best I’ve used to date
						</p>

						<figcaption>
							Jacqui<cite>Edun Customer</cite>
						</figcaption>
					</blockquote>
				</figure>
			</Quote>
		</AnimatedBlock>
	);
};

const EdunFeatures = () => {
	const [isInViewport, targetRef] = useIsInViewport({
		threshold: 25,
	});
	const [animate, setAnimate] = useState(false);

	useEffect(() => {
		if (!animate) setAnimate(isInViewport);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isInViewport]);

	return (
		<AnimatedBlock ref={targetRef} animate={animate} fillSpace>
			<H2 align="center">Features</H2>
			<FeatureList>
				<li>
					<Feature
						feature="Candidate pipeline Management"
						featureContent={
							<>
								<p>
									At Edun, we transform candidate management into a seamless and efficient process. Our Candidate Pipeline Management system organically structures and organizes
									candidate data, providing a clear and comprehensive view of each candidate&apos;s journey.
								</p>
								<p>
									This intuitive system ensures that you can easily track and manage candidate progress, from initial onboarding to ongoing engagement. Experience enhanced clarity
									and efficiency in your recruitment process, empowering your consultants to focus on what they do best &#8208; placing the right candidates in the right roles.
								</p>
							</>
						}
					/>
				</li>
				<li>
					<Feature
						feature="Electronic Document Submission, Vetting &amp; Clearance"
						featureContent={
							<>
								<p>
									Edun streamlines candidate onboarding with our cutting-edge digital onboarding feature. Simplify your recruitment process by allowing candidates to submit all
									necessary employment information through a user-friendly digital interface. Our system initiates the onboarding process by sending a unique, time-sensitive link to
									candidates, granting them access to a personalized onboarding platform.
								</p>
								<p>
									This efficient and secure method ensures a smooth transition from registration to clearance status, significantly accelerating the vetting and clearance process.
									With Edun, experience the ease of digital transformation in your recruitment workflow.
								</p>
							</>
						}
					/>
				</li>
				<li>
					<Feature
						feature="Complete booking system"
						featureContent={
							<>
								<p>
									At the heart of our CRM platform, Edun&apos;s Bookings module is the ultimate solution for bridging the gap between candidates and clients. Designed to cater to a
									wide range of business booking needs, this module simplifies the management of diverse booking types including standard placements, interviews, trials, tuition
									sessions, and permanent positions.
								</p>
								<p>
									Beyond its versatility, the system excels in handling varied pay rates, shift patterns, as well as tracking sickness and leave. This comprehensive tool lays the
									groundwork for generating timesheets and ensuring smooth operational flow.
								</p>
								<p>Embrace the efficiency of Edun&apos;s Complete Booking System and transform your scheduling process into a streamlined, effortless experience.</p>
							</>
						}
					/>
				</li>
				<li>
					<Feature
						feature="Electronic timesheeting"
						featureContent={
							<>
								<p>
									Edun&apos;s Electronic Timesheeting feature aids with the management of work hours, creating a direct link between bookings and the accurate tracking of worked
									hours. Designed for ease and precision, our timesheets evolve from bookings to become crucial tools in ensuring the integrity of billing and payroll processes.
								</p>
								<p>
									Our collaborative duel approval approach guarantees mutual consensus before timesheets reach their final status, fostering transparency and trust in every
									transaction.
								</p>
							</>
						}
					/>
				</li>
				<li>
					<Feature
						feature="Client Management"
						featureContent={
							<>
								<p>Maintain your client database and contacts, send important documents, view client interaction history from our client management module.</p>
							</>
						}
					/>
				</li>
				<li>
					<Feature
						feature="Marketing Suite"
						featureContent={
							<>
								<p>
									Elevate your communication strategy with Edun&apos;s Marketing Suite, designed to connect you swiftly and effectively with your clients and candidates. Our suite
									empowers you to craft impactful marketing campaigns using customizable templates, tailored specifically within Edun. Effortlessly build your recipient list by
									searching through your client and candidate contacts, and personalize each campaign with dynamically included content such as auto-generated candidate CVs and
									relevant attachments.
								</p>
								<p>
									Edun&apos;s Marketing Suite includes a comprehensive statistics feature, providing real-time data from the moment your campaign launches. This insight is key to
									refining your strategies, enhancing engagement, and ensuring your messages resonate with your audience. With Edun, you&apos;re not just reaching out; you&apos;re
									connecting in a way that matters.
								</p>
							</>
						}
					/>
				</li>
				<li>
					<Feature
						feature="Job Feeds Integration"
						featureContent={
							<>
								<p>
									Display your vacant placements on your website or various job feeds. Eduns job feeds integration help you reach a wider audience while maintaining a consistent
									database of candidates and applicants.
								</p>
								<p>Easily convert your applicants into candidates within Edun, process onboarding and compliance quicker.</p>
							</>
						}
					/>
				</li>
				<li>
					<Feature
						feature="Invoice Management Integration"
						featureContent={
							<>
								<p>
									Unlock a new level of financial efficiency with Edun&apos;s seamless integration with various invoice management systems. This feature is designed to simplify your
									invoice management process, ensuring that your financial data remains synchronized and effortlessly managed.
								</p>
								<p>
									<i>More integrations coming soon.</i>
								</p>
							</>
						}
					/>
				</li>
				<li>
					<Feature
						feature="Analytics and Reporting Suite"
						featureContent={
							<>
								<p>
									Edun&apos;s Analytics and Reporting Suite is a powerful tool designed to empower consultants, and administrators, with deep insights into user activities and
									performance metrics. This suite focuses on delivering transparency and actionable intelligence, enabling users to make informed decisions based on robust data
									analysis.
								</p>
								<p>
									From the detailed intricacies of candidate onboarding to broader metrics like gross profit, our module provides a comprehensive view of your operations. It&apos;s
									not just about collecting data; it&apos;s about understanding it. With our suite, you gain a panoramic view of your business, allowing you to track progress,
									identify trends, and optimize strategies for better outcomes.
								</p>
								<p>
									Edun&apos;s User Target Reporting is an essential instrument for reporting administrators, crafted to meticulously track and monitor user performance. This feature
									focuses on bringing clarity and accountability to the forefront of performance management. Our intuitive reports illuminate a consultant&apos;s performance against
									specified targets, offering a straightforward and effective way to assess progress.
								</p>
							</>
						}
					/>
				</li>
				<li>
					<Feature
						feature="Employee Management"
						featureContent={
							<>
								<p>
									Edun is designed to facilitate comprehensive management of your team&apos;s core aspects &#8208; from commission and targets to precise control over Edun
									permissions.
								</p>
								<p>
									Our platform empowers you with granular permissions, allowing for meticulous segmentation of responsibilities within Edun. This ensures that each team member has
									access to just what they need, fostering efficiency and security. Additionally, the capability to create distinct teams or branches enhances organizational
									structure, providing segmented visibility and tailored reporting.
								</p>
								<p>Embrace the power of efficient and structured employee management with Edun, and drive your team towards optimized performance and clear, measurable goals.</p>
							</>
						}
					/>
				</li>
				<li className="nofeature">
					<Feature feature="Cloud Based Infrastructure" />
				</li>
				<li className="nofeature">
					<Feature feature="Optimised for multiple devices" />
				</li>
				<li className="nofeature">
					<Feature feature="Much, much, much more!" />
				</li>
			</FeatureList>
		</AnimatedBlock>
	);
};

const Feature = ({ feature, featureContent }: { feature: string; featureContent?: JSX.Element }) => {
	const [isInViewport, targetRef] = useIsInViewport({
		threshold: 25,
	});
	const [animate, setAnimate] = useState(false);

	const [active, setActive] = useState<boolean>(false);

	useEffect(() => {
		if (!animate) setAnimate(isInViewport);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isInViewport]);

	return (
		<AnimatedBlock ref={targetRef} animate={animate} fillSpace>
			<span>{feature}</span>
			{featureContent ? (
				<div>
					{active ? <div className="featureContent">{featureContent}</div> : null}
					<a onClick={() => setActive(!active)}>
						{active ? "View less" : "Find out more"} {active ? <>&#8593;</> : <>&#8595;</>}
					</a>
				</div>
			) : null}
		</AnimatedBlock>
	);
};

const Register = () => {
	const [isInViewport, targetRef] = useIsInViewport({
		threshold: 25,
	});
	const [animate, setAnimate] = useState(false);

	useEffect(() => {
		if (!animate) setAnimate(isInViewport);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isInViewport]);

	return (
		<AnimatedBlock ref={targetRef} animate={animate} delay>
			<H2 align="center">Ready to jump into edun?</H2>
			<ButtonList justify="center">
				<RegisterInterest />
			</ButtonList>
			<div style={{ marginTop: "50px", textAlign: "center" }}>
				<BulletList nobullet={true}>
					<li>
						<a href="mailto:info@helloedun.co.uk">info@helloedun.co.uk</a>
					</li>
					<li>
						<a href="tel:0191 406 9222">0191 406 9222</a>
					</li>
					<li>
						<a href="https://uk.linkedin.com/company/edun-crm" target="_blank" rel="noopener noreferrer">
							LinkedIn
						</a>
					</li>
				</BulletList>
			</div>
		</AnimatedBlock>
	);
};

const About = forwardRef<HTMLDivElement>((props, ref) => {
	return (
		<>
			<ContentContain flushTop>
				<FloatingContentSection>
					<Row>
						<Col span={4} center span1024={12}>
							<About1 />
						</Col>
						<Col span={8} center span1024={12}>
							<PromoVideo />
						</Col>
					</Row>
				</FloatingContentSection>
			</ContentContain>
			<ClearContain>
				<ContentContain>
					<FloatingContentSection>
						<Row reverse>
							<Col span={4} center span1024={12}>
								<About2 />
							</Col>
							<Col span={8} center span1024={12}>
								<About2Image />
							</Col>
						</Row>
					</FloatingContentSection>
				</ContentContain>
			</ClearContain>
			<ContentContain>
				<FloatingContentSection>
					<Row>
						<Col span={8} offsetLeft={2} span1024={12} offsetLeft1024={0}>
							<EdunFeatures />
						</Col>
					</Row>
				</FloatingContentSection>
			</ContentContain>
			<ClearContain>
				<ContentContain>
					<FloatingContentSection>
						<Row>
							<Col span={4} center span1024={12}>
								<About3 />
							</Col>
							<Col span={8} center span1024={12}>
								<About3Image />
							</Col>
						</Row>
					</FloatingContentSection>
				</ContentContain>
				<ContentContain>
					<FloatingContentSection small>
						<Row>
							<Col span={8} center span1024={12}>
								<div ref={ref}>
									<EdunQuote />
								</div>
							</Col>
						</Row>
					</FloatingContentSection>
				</ContentContain>
			</ClearContain>
			<ClearContain>
				<StandardContain>
					<Register />
				</StandardContain>
			</ClearContain>
		</>
	);
});

About.displayName = "About";

export default About;
